import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import VueApexCharts from 'vue-apexcharts';
import router from './router'
import store from './store'
import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import Vuetify from 'vuetify'
import VueJwtDecode from 'vue-jwt-decode'

async function check_token() {
  let token = VueJwtDecode.decode(localStorage.getItem("access_token") || '');
  let token_time = token ? token.exp : 0;
  let time =  Math.floor(Date.now() / 1000) + 1000;
  let refresh = localStorage.getItem("refresh_token");
  if (!refresh) throw new axios.Cancel('cancel');
  if (token_time < time && refresh) {
    // window.console.log('!!!!');
    return fetch('https://auth.oboi.ru/token/refresh', {
          method: 'POST',
          headers: {"Authorization": 'Bearer ' +
                    localStorage.getItem("refresh_token")}
    }).then(res => res.json())
      .then(json => {
        // window.console.log(json.access_token);
        if (json.access_token)
          localStorage.setItem("access_token", json.access_token);
      })
  }
}

axios.interceptors.request.use(request => {
      return check_token().then(() => {
        if (!request.headers['Authorization'])
          request.headers['Authorization'] =
              `Bearer ${localStorage.getItem("access_token")}`;
        if (typeof(request.data) == 'string'){
            request.data = JSON.parse(request.data);
        }
        // window.console.log(request);
        return request;
      });
});

const refreshAuthLogic = failedRequest => 
    axios.post('https://auth.oboi.ru/token/refresh', {}, {headers: {
          "Authorization": 'Bearer ' + localStorage.getItem("refresh_token")
      }})
      .then(tokenRefreshResponse => {
            localStorage.setItem("access_token",
                                 tokenRefreshResponse.data.access_token);
            failedRequest.response.config.headers['Authorization'] =
                'Bearer ' + tokenRefreshResponse.data.access_token;
            return Promise.resolve();
      })
    .catch(() => {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      router.push({name: 'Login'});
    });

createAuthRefreshInterceptor(axios, refreshAuthLogic,
                             {statusCodes: [401, 422]});


Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false

Vue.filter('moneyM', function (value) {
    if (isNaN(value)) return "0`000"
    return (Number(value) / 1000000).toFixed(3).replace(".", "`");
})

Vue.filter('moneyT', function (value) {
    if (isNaN(value)) return "0 000"
    return (Number(value) / 1000).toFixed(3).replace(".", " ");
})

Vue.filter('money', function (number) { 
    var format = new Intl.NumberFormat('ru');
    if (isNaN(number)) return 0
    if (number <= 1) return number
    return format.format(Number(number).toFixed());
})

Vue.use(Vuetify);

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
